<!-- Toast Messages - Positioned at root level -->
<p-toast
  position="top-right"
  [baseZIndex]="9999"
  [autoZIndex]="true"
  [showTransformOptions]="'translateX(100%)'"
  [hideTransformOptions]="'translateX(100%)'"
  [showTransitionOptions]="'0.3s ease-in'"
  [hideTransitionOptions]="'0.3s ease-out'"
  [preventDuplicates]="false"
></p-toast>

<div class="p-6 flex-table-page">
  <!-- Header -->
  <h2 class="text-2xl font-semibold text-gray-800 mb-3 flex-table-header">
    {{ "brand.management.title" | translate }}
  </h2>

  <app-search-form
    [searchFormat]="searchConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
      <app-status-filter
        [primaryButton]="primaryButton()"
        [secondaryButton]="secondaryButton()"
        (primaryButtonClick)="onAdd()"
        (secondaryButtonClick)="onBatchDelete()"
      ></app-status-filter>
    </div>
  </app-search-form>

  <!-- Data Table -->
  <div class="flex-table-section">
    <advanced-data-table
      #advancedTable
      [dataSource]="brands()"
      [defaultColumns]="defaultColumns()"
      [flexibleColumns]="flexibleColumns()"
      [loading]="loading()"
      [rows]="searchParams().size"
      [first]="(searchParams().page - 1) * searchParams().size"
      [totalRecords]="totalRecords()"
      [hasCheckColumn]="canDelete()"
      [selection]="selectedBrands()"
      (selectionChange)="onSelectionChange($event)"
      (pageChange)="onPageChange($event)"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      class="w-full"
    >
      <!-- Custom Template for logo and date -->
      <ng-template
        #customTemplate
        let-value
        let-rowData="rowData"
        let-column="column"
      >
        @if (column && column.template === "dateTemplate") {
          <span class="text-xs text-gray-600">
            {{ formatDateTime(value) }}
          </span>
        } @else if (column && column.template === "logoTemplate") {
          <div class="flex items-center justify-center">
            @if (value) {
              <img
                [src]="value"
                [alt]="'Brand Logo'"
                class="w-12 h-12 object-cover rounded-md border border-gray-200"
                (error)="onImageError($event)"
              />
              <div
                class="w-12 h-12 bg-gray-100 rounded-md border border-gray-200 flex items-center justify-center image-placeholder"
                style="display: none"
              >
                <i class="pi pi-image text-gray-400"></i>
              </div>
            }
          </div>
        }
      </ng-template>

    <!-- Custom Status Template -->
    <ng-template #statusTemplate let-status>
      <div class="flex items-center justify-center gap-1">
        <p-tag
          [value]="getStatusDisplayText(status)"
          [severity]="getStatusSeverity(status)"
          styleClass="status-tag"
          [ngStyle]="getStatusStyle(status)"
          [pTooltip]="
            status
              ? ('brand.status.active' | translate)
              : ('brand.status.inactive' | translate)
          "
          tooltipPosition="top"
          tooltipStyleClass="custom-tooltip"
          [showDelay]="300"
          [hideDelay]="0"
        />
      </div>
    </ng-template>

    <!-- Custom Actions Template -->
    <ng-template #actionsTemplate let-rowData>
      <div class="flex gap-2 justify-center">
        @if (canUpdate()) {
          <app-button
            class="action-edit"
            [label]="'brand.actions.edit' | translate"
            type="action"
            (emitOnClick)="onEdit(rowData)"
          ></app-button>
        }
        @if (canApprove()) {
          <app-button
            [class]="rowData.status ? 'action-disable' : 'action-enable'"
            [label]="
              rowData.status
                ? ('brand.actions.deactivate' | translate)
                : ('brand.actions.activate' | translate)
            "
            type="action"
            (emitOnClick)="onStatusChange(rowData, !rowData.status)"
          ></app-button>
        }
        @if (canDelete()) {
          <app-button
            class="action-delete"
            [label]="'brand.actions.delete' | translate"
            type="action"
            [disabled]="rowData.status"
            [tooltip]="
              rowData.status
                ? ('brand.messages.warning.cannot_delete_active_brands'
                  | translate)
                : ''
            "
            tooltipPosition="top"
            [showDelay]="300"
            (emitOnClick)="onDelete(rowData)"
          ></app-button>
        }
      </div>
    </ng-template>
    </advanced-data-table>
  </div>
</div>

<!-- Shared Confirmation Dialog -->
<app-confirmation-dialog
  [(visible)]="showConfirmationDialog"
  [title]="dialogTitle"
  [message]="dialogMessage"
  [buttons]="dialogButtons"
  (emitOnClick)="onConfirmatiButtonClick($event)"
></app-confirmation-dialog>
